// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Watchlist Overlay – Tier-based urgency colors for 200+ satellite ops */

#info-overlay-menu {
  --wl-color-active: #ffd700;
  --wl-color-imminent: #00ff88;
  --wl-color-upcoming: #00cfff;
  --wl-color-aware: #0077dd;
  --wl-color-background: rgba(180, 180, 200, 0.7);
  --wl-color-departed: rgba(140, 140, 160, 0.5);
}

/* Override global overflow: hidden to allow scrolling with 200+ entries */
#info-overlay-content {
  overflow-y: auto !important;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
}

#info-overlay-content::-webkit-scrollbar {
  width: 4px;
}

#info-overlay-content::-webkit-scrollbar-track {
  background: transparent;
}

#info-overlay-content::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

/* Compact entry row */
.wl-entry {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  font-size: 15px;
  line-height: 1.4;
  transition: background 0.15s;
}

.wl-entry:hover {
  background: rgba(255, 255, 255, 0.08);
}

.wl-name {
  flex-shrink: 0;
  min-width: 50px;
}

/* Per-list color dot (pro multi-list feature) */
.wl-list-dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.35);
}

.wl-countdown {
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.wl-time {
  margin-left: auto;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

/* Tier color classes – sized for large TV displays viewed at distance */

.wl-tier-active {
  color: var(--wl-color-active);
  font-size: 16px;
  font-weight: 700;
}

.wl-tier-imminent {
  color: var(--wl-color-imminent);
  font-size: 16px;
  font-weight: 700;
}

.wl-tier-upcoming {
  color: var(--wl-color-upcoming);
  font-size: 15px;
}

.wl-tier-aware {
  color: var(--wl-color-aware);
  font-size: 15px;
}

.wl-tier-background {
  color: var(--wl-color-background);
  font-size: 14px;
}

.wl-tier-departed {
  color: var(--wl-color-departed);
  font-size: 14px;
  font-style: italic;
}

/* Group headers between tiers */
.wl-group-header {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.35);
  padding: 6px 8px 2px;
  user-select: none;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/watchlist/watchlist-overlay.css"],"names":[],"mappings":"AAAA,yEAAyE;;AAEzE;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,4BAA4B;EAC5B,yBAAyB;EACzB,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA,0EAA0E;AAC1E;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iDAAiD;EACjD,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA,wEAAwE;;AAExE;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":["/* Watchlist Overlay – Tier-based urgency colors for 200+ satellite ops */\n\n#info-overlay-menu {\n  --wl-color-active: #ffd700;\n  --wl-color-imminent: #00ff88;\n  --wl-color-upcoming: #00cfff;\n  --wl-color-aware: #0077dd;\n  --wl-color-background: rgba(180, 180, 200, 0.7);\n  --wl-color-departed: rgba(140, 140, 160, 0.5);\n}\n\n/* Override global overflow: hidden to allow scrolling with 200+ entries */\n#info-overlay-content {\n  overflow-y: auto !important;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.2) transparent;\n}\n\n#info-overlay-content::-webkit-scrollbar {\n  width: 4px;\n}\n\n#info-overlay-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n#info-overlay-content::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n/* Compact entry row */\n.wl-entry {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n  font-size: 15px;\n  line-height: 1.4;\n  transition: background 0.15s;\n}\n\n.wl-entry:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.wl-name {\n  flex-shrink: 0;\n  min-width: 50px;\n}\n\n/* Per-list color dot (pro multi-list feature) */\n.wl-list-dot {\n  flex-shrink: 0;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n}\n\n.wl-countdown {\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n}\n\n.wl-time {\n  margin-left: auto;\n  flex-shrink: 0;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Tier color classes – sized for large TV displays viewed at distance */\n\n.wl-tier-active {\n  color: var(--wl-color-active);\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.wl-tier-imminent {\n  color: var(--wl-color-imminent);\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.wl-tier-upcoming {\n  color: var(--wl-color-upcoming);\n  font-size: 15px;\n}\n\n.wl-tier-aware {\n  color: var(--wl-color-aware);\n  font-size: 15px;\n}\n\n.wl-tier-background {\n  color: var(--wl-color-background);\n  font-size: 14px;\n}\n\n.wl-tier-departed {\n  color: var(--wl-color-departed);\n  font-size: 14px;\n  font-style: italic;\n}\n\n/* Group headers between tiers */\n.wl-group-header {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.35);\n  padding: 6px 8px 2px;\n  user-select: none;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
